import { createAccountQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useAccountQuery = createAccountQuery(HTTP_CONFIG.API.Optimizely.url)
